// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Firebolt = function Firebolt(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M13.539 6.5a7.07 7.07 0 0 0-1.85-.961L.836 1.358l.86 1.99L8.3 5.98l.65.259-.425 1.109-1.318-.525-4.553-1.812L3.748 6.98l2.623 1.049 2.558 1.023-.429 1.109L6 9.188l-1.286-.5a13.362 13.362 0 0 0 2.125 4.093 4.615 4.615 0 0 0 3.706 1.86h.1a4.62 4.62 0 0 0 2.9-8.136z' })
  );
};

Firebolt.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Firebolt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Firebolt.js
// module id = 1031
// module chunks = 1